import { createAsyncThunk } from '@reduxjs/toolkit';

// Fire-and-forget seen-flag writes. No extraReducers: the local notification state is
// updated separately by the reset-*-seen-status thunks; these only persist the flags.

export interface PutFormSeenFlagArguments {
    projectId: number;
    formId: number;
}

export const putFormSeenFlag = createAsyncThunk(
    'dataRequestNotifications/putFormSeenFlag',
    async (args: PutFormSeenFlagArguments, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        await axios.put(
            `/api/DataRequestProjects/${args.projectId}/dataForm/${args.formId}/seenFlag`
        );
    }
);

export interface PutQuestionsSeenFlagArguments {
    projectId: number;
    formId: number;
    questionsIds: number[];
    subQuestionsIds: number[];
}

export const putQuestionsSeenFlag = createAsyncThunk(
    'dataRequestNotifications/putQuestionsSeenFlag',
    async (args: PutQuestionsSeenFlagArguments, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        await axios.put(
            `/api/DataRequestProject/${args.projectId}/dataForm/${args.formId}/questions/seenFlag`,
            {
                questionsIds: args.questionsIds,
                // The wire key intentionally matches the misspelled backend contract
                // property (PutMarkQuestionsAsSeen.SubQuesitonsIds).
                subQuesitonsIds: args.subQuestionsIds,
            }
        );
    }
);

export interface PutViewSeenFlagArguments {
    projectId: number;
    tableId: number;
    viewId: number;
}

export const putViewSeenFlag = createAsyncThunk(
    'dataRequestNotifications/putViewSeenFlag',
    async (args: PutViewSeenFlagArguments, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        await axios.put(
            `/api/dataRequestProjects/${args.projectId}/dataTables/${args.tableId}/DataTableViews/${args.viewId}/seenFlag`
        );
    }
);
